import React, { useContext } from 'react';
import { Context } from '../../services/_globalContext/context';

export default function StartupErrorComponent() {
  const ctx = useContext(Context);

  return (
    <article className="App" style={{ textAlign: 'unset' }}>
      <div className="grid-container">
        <ul>
          {!ctx.deviceCapabilities.hasLocalStorage && (
            <li>
              <div className="callout alert">
                <h4>LocalStorage unavailable</h4>
                <p>Unable to complete startup, LocalStorage unavailable.</p>
                <p>Ensure browser is not in private mode.</p>
              </div>
            </li>
          )}
          {(!ctx.deviceCapabilities.hasFetch ||
            !ctx.deviceCapabilities.hasPromise ||
            !ctx.deviceCapabilities.hasTextEncoder) && (
            <li>
              <div className="callout alert">
                <h5>Incompatible device!</h5>
                <p>Unable to complete startup. Missing core browser capabilities.</p>
                <p>
                  Fadila requires a modern browser to run, please update your browser and/or device
                  and try again.
                </p>
              </div>
            </li>
          )}
        </ul>
      </div>
    </article>
  );
}
